import { EntityDtoBase } from './Common'

export enum UserRole {
    NotSet = 0,
    User = 1,
    Admin = 2,
}

export interface UserDto extends EntityDtoBase {
    username: string
    role: UserRole
}
